import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter3.jsx';
import AsoMultiFilter from '../../filters/AsoMultiFilter.jsx';
import BeatPlanFilters from '../../filters/BeatPlanFilters.jsx';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../../helpers/utils.js';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var today = moment().format('YYYY-MM-DD');
var date_config = date_range_config('0', '0', today,'0');
var BeatPlanReportTable='';

class BeatPlanReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            ciutidIds: '',
            loading:false,
            isChange: false,
            object_code:[],
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            aso_names:"",
            store_category: [],
            store_code: [],
            city: [],
            visit_status: [],
            storeCategoryValue: [],
            storeCodeValue: [],
            cityValue: [],
            visitStatusValue: [],
            download_limit:31,
            is_history: false,
            canDelete: false
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");


        //isReportAccess(AllAccessPermissions, 'GRD_dump_report');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });


    }
    componentDidUpdate() {

    }
    componentDidMount() {
        //this.get_download_limit();
        this.get_delete_access();
        this.get_filtered_aso_clockin_report('');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'live_transaction_dump_report','sparcs')

    }
    get_delete_access() {
        axios.post(config.get('API_URL') + '/InternalReport/beatplan_delete_access', {}, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            const canDelete = !!(response.data && response.data.data && response.data.data.can_delete);
            this.setState({ canDelete }, () => {
                // The table may have already drawn before access resolved; redraw so
                // the delete column reflects the resolved permission.
                if (canDelete && $.fn.DataTable.isDataTable('#BeatPlanReportTable')) {
                    $('#BeatPlanReportTable').DataTable().ajax.reload(null, false);
                }
            });
        }).catch(error => {
            console.error(error);
            // Fail closed: if we can't confirm access, hide the delete option.
            this.setState({ canDelete: false });
        });
    }


    downLoadClockinReport (e){


        let filters = {
            aso_name: this.state.aso_names,
            store_category: this.state.store_category,
            store_codes: this.state.store_code,
            city_names: this.state.city,
            visit_status: this.state.visit_status,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            report_code:'aso_beatplan_report',
            user_id: this.state.user_id,
            download: 1,
            is_history: this.state.is_history ? '1' : '0',
        }
        this.setState({
            filters:filters
        })

        this.refs.downloadAllReport.downLoadReport(filters, '/sro_connectv2/aso_beatplan_report','aso_beatplan_report',90);

    }

    get_filtered_aso_clockin_report() {
//         console.log(tableHeaders);
//         console.log(tableBody);
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);


        var postData = {
            aso_name: this.state.aso_names,
            store_category: this.state.store_category,
            store_codes: this.state.store_code,
            city_names: this.state.city,
            visit_status: this.state.visit_status,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:'aso_beatplan_report',
            user_id: this.state.user_id,
            is_history: this.state.is_history ? '1' : '0',
        };
        if ($.fn.DataTable.isDataTable('#BeatPlanReportTable')) {
            $('#BeatPlanReportTable').DataTable().clear().destroy();
        }

        BeatPlanReportTable = $('#BeatPlanReportTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": true,
                "responsive": false,
                "scrollX": false,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/aso_beatplan_report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                        console.log("complete", data);
                    },
                },

                columns:[
                    {"data":"beatplan_date"},
                    {"data":"employee_id_and_name"},
                    {"data":"store_name"},
                    {"data":"store_category"},
//                     {"data":"store_priority"},
                    {"data": "store_code"},
                    {"data": "city"},
                    {"data": "visit_priority"},
                    {"data": "visit_status"},
                    {"data": "visit_started_at"},
                    {"data": "pkyc_ticket_id"},
                    {"data": "reason_text"},
                    {"data": "id"}

                    ],
                "columnDefs": [
                    {
                        "targets": 7,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {//console.log(rowData.Status);
                        //console.log(td);
                            if (rowData.visit_status == 'Completed') {
                                $(td).addClass('doneLog');
                            }
                            if (rowData.visit_status == 'InProgress') {
                                $(td).addClass('ongoingLog');
                            }
                            if (rowData.visit_status == 'NotStarted') {
                                $(td).addClass('failedLog');
                            }
                            if (rowData.visit_status == 'Exit') {
                                $(td).addClass('stopedLog');
                            }
                        },
                    },
                   {  render: function (data) {
                       if(data=='' || data==null || data=='null') {
                           return ""
                           } else {
                               return "<div class='text-wrap width-80'>" +moment(data).format('D MMM YYYY HH:mm:ss')+ "</div>";

                               }
                               },
                        "width": "80px",
                        "targets": 8
                    },
                    {
                    "width": "50px",
                     "className":"text-center",
                    "targets": 11,
                    "data": "data",
                    "createdCell": (td, cellData, rowData, row, col) => {
                        $(td).text('');
                        if (rowData.store_category != 'PKYC') {
                            const viewLink = $('<a href="#" data-tip="View" title="View KYC Documents" id="re_run" class="RerunButton" >View</a>');
                            viewLink.on('click', e => {
                                e.preventDefault();
                                this.view_details(e, rowData);
                            });
                            $(td).append(viewLink);
                        }
                        // Delete only for current-date entries that have not started yet,
                        // and only when the user is listed in the Beatplan_Del_Access config.
                        if (this.state.canDelete && !this.state.is_history && rowData.visit_status === 'NotStarted') {
                            const deleteLink = $('<a href="#" data-tip="Delete" title="Delete Beat Plan" class="RerunButton" style="margin-left:8px; background-color:#d9534f; border-color:#d43f3f; color:#ffffff;" >Delete</a>');
                            deleteLink.on('click', e => {
                                e.preventDefault();
                                this.beatplan_delete(e, rowData);
                            });
                            $(td).append(deleteLink);
                        }
                    },
                    bSortable: false,
                }
                ],
            });


    }
    view_details(e, rowData) {
        const { beatplan_date, aso_employeecode, store_code,store_name } = rowData;
        const { history } = this.props;
        const is_history = this.state.is_history ? '1' : '0';
        const queryParams = new URLSearchParams({
            beatplan_date: encodeURIComponent(beatplan_date),
            aso_employeecode: encodeURIComponent(aso_employeecode),
            store_code: encodeURIComponent(store_code),
            store_name: encodeURIComponent(store_name),
            is_history: is_history,
        });

        history.push(`/admin/view-beat-plan-details?${queryParams.toString()}`);

    }
    beatplan_delete(e, rowData) {
        confirmAlert({
            title: 'Confirm Delete',
            message: `Are you sure you want to delete the beat plan for "${rowData.store_name}" (${rowData.store_code}) on ${rowData.beatplan_date}?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        this.handleClickDelete(rowData);
                    }
                },
                {
                    label: 'No',
                }
            ]
        });
    }
    handleClickDelete(rowData) {
        const data = {
            store_code: rowData.store_code,
            beatplan_date: rowData.beatplan_date,
            aso_employeecode: rowData.aso_employeecode,
            delete_request_by: jwt_decode(localStorage.usertoken).email
        };
        axios.post(config.get('API_URL') + '/InternalReport/delete_beatplan', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if (response.data && response.data.error) {
                alert(typeof response.data.error === 'string' ? response.data.error : 'Failed to delete beat plan.');
            } else {
                const msg = (response.data && response.data.data && response.data.data.message) || 'Beat plan deleted successfully.';
                alert(msg);
                if ($.fn.DataTable.isDataTable('#BeatPlanReportTable')) {
                    $('#BeatPlanReportTable').DataTable().ajax.reload(null, false);
                }
            }
        }).catch(error => {
            console.error(error);
            const errorMsg = (error.response && error.response.data && error.response.data.message) || 'Something went wrong while deleting the beat plan.';
            alert(errorMsg);
        });
    }
    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
//         if(this.state.object_type==='Innoviti')
//         {
//
//             this.refs.reloadUtid.ci_utid('','','',false,'');
//         }
        this.refs.asoNameFilter.restAsoFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            aso_names:'',
            store_category: [],
            store_code: [],
            city: [],
            visit_status: [],
            storeCategoryValue: [],
            storeCodeValue: [],
            cityValue: [],
            visitStatusValue: [],
            ciutidIds: '',
            isChange: false,
            is_history: false,
            dateFromLimit: date_config.start_date_limit,
            dateLimit: date_config.end_date_limit

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleAsoEvents = (optionSelected, event_names) =>
    {
        this.setState({
            aso_names:event_names,
            isChange: true
        });
    }

    handleDateTypeChange = (e) =>
    {
        const is_history = e.target.value === 'history' ? true : false;
        const today = moment().format('YYYY-MM-DD');

        if (is_history) {
            // PREVIOUS DATE MODE
            var date_config_prev = date_range_config('1', '1', '2020-02-01','1');
            this.setState({
                is_history: true,
                isChange: true,
                datefrom: date_config_prev.start_date,
                dateTo: date_config_prev.end_date,
                datefromShow: date_config_prev.display_start_date,
                dateToShow: date_config_prev.display_end_date,
                yestSend: date_config_prev.start_date_value,
                todSend: date_config_prev.end_date_value,
                dateFromLimit: date_config_prev.start_date_limit,
                dateLimit: date_config.end_date_limit,
            });
        } else {
            // CURRENT DATE MODE
            var date_config_curr = date_range_config('0', '0', today,'0');
            const futureLimit = moment().add(30, 'days').format('YYYY-MM-DD');  // Today + 30 days
            this.setState({
                is_history: false,
                isChange: true,
                datefrom: date_config_curr.start_date,
                dateTo: date_config_curr.end_date,
                datefromShow: date_config_curr.display_start_date,
                dateToShow: date_config_curr.display_end_date,
                yestSend: date_config_curr.start_date_value,
                todSend: date_config_curr.end_date_value,
                dateFromLimit: today,  // Disable past dates (set min to today)
                dateLimit: date_config.end_date_limit
            });
        }
    }

    handleFilterChange = (name, values, optionSelected) => {
        // This handler receives filter updates from BeatPlanFilters.
        // name: The field name (e.g., 'store_code', 'city', 'visit_status').
        // values: The actual values to be sent to the backend (e.g., array of store codes).
        // optionSelected: The UI state (e.g., array of selected options for ReactMultiSelectCheckboxes).
        // Note: For 'store_code', optionSelected will be null as specific UI state is managed by StoreFilter2.

        // Map the backend-friendly name to the state value name pattern used in render
        const valueNameMap = {
            'store_category': 'storeCategoryValue',
            'store_code': 'storeCodeValue',
            'city': 'cityValue',
            'visit_status': 'visitStatusValue'
        };

        const valueName = valueNameMap[name];
        
        this.setState({
            [name]: values, // The actual values (codes, categories, etc.) for API payload
            [valueName]: optionSelected, // The UI selection objects to maintain dropdown state
            isChange: true
        });
    }

    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">ASO Beat Plan reports</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {/* Handles filters. Uses StoreFilter2 for store selection. */}
                                            <div className="row">
                                            <BeatPlanFilters
                                                storeCategoryValue={this.state.storeCategoryValue}
                                                cityValue={this.state.cityValue}
                                                visitStatusValue={this.state.visitStatusValue}
                                                onFilterChange={this.handleFilterChange}
                                                object_type={this.state.object_type}
                                                object_code={this.state.object_code}
                                                user_type={this.state.userType}
                                            />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="col-md-3 filter-bottom5 padd-5">
                                                <div><label>Select Date Type: </label></div>
                                                <div style={{marginTop: '5px'}}>
                                                    <label style={{marginRight: '15px', fontWeight: 'normal'}}>
                                                        <input
                                                            type="radio"
                                                            name="dateType"
                                                            value="current"
                                                            checked={!this.state.is_history}
                                                            onChange={this.handleDateTypeChange}
                                                            style={{marginRight: '5px'}}
                                                        />
                                                        Current Date
                                                    </label>
                                                    <label style={{fontWeight: 'normal'}}>
                                                        <input
                                                            type="radio"
                                                            name="dateType"
                                                            value="history"
                                                            checked={this.state.is_history}
                                                            onChange={this.handleDateTypeChange}
                                                            style={{marginRight: '5px'}}
                                                        />
                                                        Previous Date
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label>Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {moment(this.state.dateFromLimit)} end_date_limit = {moment(this.state.dateLimit)} is_history = {this.state.is_history} />
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> ASO Name </label>
                                                <AsoMultiFilter ref="asoNameFilter" onSelectaso = {this.handleAsoEvents} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-5 pull-right marginTop">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_aso_clockin_report.bind(this)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                            
                                        </div>


                                    </div>
                                    <div className="row">

                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadClockinReport.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="BeatPlanReportTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Beat Plan Date</th>
                                                <th>ASO Employee Code and Name</th>
                                                <th>Store Name</th>
                                                <th>Store Category</th>
{/*                                                 <th>Store Priority</th> */}
                                                <th>Store Code</th>
                                                <th>City</th>
                                                <th>Visit Priority</th>
                                                <th>Visit Status</th>
                                                <th>Visit Start at</th>
                                                <th>PKYC Ticket ID</th>
                                                <th>Exit Reason</th>
                                                <th>Details</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(BeatPlanReport)